module.exports = __webpack_public_path__ + "72fcf992c1712e4cb62bad282310e362.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/gildan-5050-hoodie-blue.png
// module id = 836
// module chunks = 0